import { payloadDefaultProp } from '@/containers/header/dynamicDropdown'
import { WidgetMap } from '@/lib/utils'
import { CustomerObj } from '@/lib/utils.type'
import { SiteObj } from '@/services/types/api.types'
import { createSlice } from '@reduxjs/toolkit'

type menuSlicetype = {
  items: {
    path: string
    id: string
    name: string
    children: {
      path: string
      label: string
      children?: string[]
    }[]
  }[]
  paths: string[]
  perms: { [key: string]: string[] }
  menuExpanded: boolean
  appLoader: boolean
  siteDetails: SiteObj[]
  siteCustomerDetails: CustomerObj[]
  payloadDef: payloadDefaultProp
  drilldown?: boolean
  value: 'light' | 'dark' | 'high-contrast-light' | 'high-contrast-dark'
  isMap?: boolean
  widgets: WidgetMap
  fontChangePx: number
  toHideSideBar?: boolean
  overView: string
  webtour: boolean
}

const initialState: menuSlicetype = {
  paths: [],
  items: [],
  perms: {},
  menuExpanded: true,
  appLoader: true,
  siteDetails: [],
  siteCustomerDetails: [],
  drilldown: false,
  payloadDef: {
    customerId: [],
    siteId: [],
    billingSubGroup: '',
    customerName: '',
  },
  value: 'light',
  isMap: false,
  widgets: {},
  fontChangePx: 0,
  toHideSideBar: false,
  overView: 'Home',
  webtour: false,
}

const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    setPerms: (state, action) => {
      state.perms = action.payload
    },
    setPaths: (state, action) => {
      state.paths = action.payload
    },
    setWidgets: (state, action) => {
      state.widgets = action.payload
    },
    setMenuItems: (state, action) => {
      state.items = action.payload
    },
    setAppLoader: (state, action) => {
      state.appLoader = action.payload
    },
    clearMenuItems: state => {
      state.items = []
    },
    changeMenuStatus: (state, action) => {
      state.menuExpanded = action.payload
    },
    setSiteDetails: (state, action) => {
      state.siteDetails = action.payload
    },
    setpayloadDef: (state, action) => {
      state.payloadDef = action.payload
    },
    setDrillDown: (state, action) => {
      state.drilldown = action.payload
    },
    setCustomerDetails: (state, action) => {
      state.siteCustomerDetails = action.payload
    },
    setValue: (state, action) => {
      state.value = action.payload
    },
    setIsMap: (state, action) => {
      state.isMap = action.payload
    },
    setToHideSideBar: (state, action) => {
      state.toHideSideBar = action.payload
    },
    setFontChangePx: (state, action) => {
      state.fontChangePx = action.payload
    },
    setOverView: (state, action) => {
      state.overView = action.payload
    },
    setWebTour: (state, action) => {
      state.webtour = action.payload
    },
    /**
     * Updates the menu items in the state. The update is done by index and sub index.
     * @param {PayloadAction<{ index: number; subIndex: number; newChildren: string[] }>} action The action to update the state with.
     */
  },
})

export const {
  setWidgets,
  setPaths,
  setPerms,
  setMenuItems,
  clearMenuItems,
  changeMenuStatus,
  setAppLoader,
  setSiteDetails,
  setCustomerDetails,
  setpayloadDef,
  setDrillDown,
  setValue,
  setIsMap,
  setFontChangePx,
  setToHideSideBar,
  setOverView,
  setWebTour,
} = menuSlice.actions
export default menuSlice.reducer
